import React, {useState} from "react";
import '../../assets/css/modals/Modals.css';
import '../../assets/css/modals/LandingModals.css';
import flyingEduman from '../../assets/images/Asset-1.svg';
import NormalSizeCloseBtn from "../buttons/NormalSizeCloseBtn";



const LandingModal = ({children, setFalseArr, alignLeft, alignRight}) => {
    return(
        <div className="modalBlur" onClick={(e) => {
            if(e.target.classList.contains('modalBlur')){
                setFalseArr.forEach(setFalse => {
                    setFalse(false);
                })
            }
        }}>
            <div className={"landingModal flex flexAlignCenter" + ((alignLeft && !alignRight) ? " flexJustifyStart" : "") + ((alignRight && !alignLeft) ? " flexJustifyEnd" : "") + (((!alignLeft && !alignRight) || (alignLeft && alignRight)) ? " flexCenter" : "")}>
                <NormalSizeCloseBtn setFalseArr={setFalseArr} />
                {children}
            </div>
        </div>
    );
};

export default LandingModal;